<template>
    <div>
        <message-cloud :message="{ direction: 'outbound', ...props.snippet }"
            :showDetails="false"
            @mediaPlaceholderClick="
                ($event) => {
                    if ($event.isFileExpired) {
                        mediaExpiredModal = true;
                    }
                }
            "
        ></message-cloud>

        <expired-media-modal v-model="mediaExpiredModal"></expired-media-modal>
    </div>
</template>

<script setup>
import ExpiredMediaModal from '~/components/modals/ExpiredMediaModal.vue';
import MessageCloud from '~/components/messages/browser-extension/components/misc/MessageCloud.vue';

const props = defineProps({
    snippet: {
        type: Object,
        required: true,
    },
});

const mediaExpiredModal = defineModel('nestedModal', {
    type: Boolean,
    required: false,
    default: false,
});
</script>
